// extracted by mini-css-extract-plugin
export var logo_svg = "logo-module--logo_svg--3Z6Tg";
export var container = "logo-module--container--3GKOZ";